export default {"src":"/_next/static/media/status.a70b6925.svg","height":100,"width":200};